import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { debounce } from 'lodash';

import { updateOrg } from '../service/management';
import { notify } from '../utils/helper';
import { makeSelectUser } from '../store/selectors';

export const ThemeContext = React.createContext();

const ThemeProvider = ({ children }) => {
  const [primaryColor, setPrimaryColor] = useState('#181c34');
  const [headerColor, setHeaderColor] = useState('#181c34');
  const [logo, setLogo] = useState('');
  const [orgId, setOrgId] = useState('');
  const user = useSelector(makeSelectUser());

  useEffect(() => {
    const theme = localStorage.getItem('theme');

    if (theme) {
      const themeObj = JSON.parse(theme);
      setPrimaryColor(themeObj.primaryColor);
      setHeaderColor(themeObj.headerColor);
      setLogo(themeObj.logo);
    }
  }, []);

  useEffect(() => {
    if (user) {
      setOrgId(user.org);
    }
  }, [user]);

  const setTheme = (pColor, hColor, lg) => {
    setPrimaryColor(pColor || '#181c34');
    setHeaderColor(hColor || '#181c34');
    setLogo(lg || '');
    localStorage.setItem(
      'theme',
      JSON.stringify({
        primaryColor: pColor || '#181c34',
        headerColor: hColor || '#181c34',
        logo: lg,
      })
    );
  };

  const handleChangeTheme = (key) =>
    debounce(async (value, needUpdate = true) => {
      if (key === 'primary') {
        setPrimaryColor(value || '#181c34');
        orgId &&
          needUpdate &&
          (await updateOrg(orgId, {
            theme: {
              primaryColor: value || '#181c34',
              headerColor,
              logo,
            },
          }));

        localStorage.setItem(
          'theme',
          JSON.stringify({
            primaryColor: value || '#181c34',
            headerColor,
            logo,
          })
        );
      } else if (key === 'header') {
        setHeaderColor(value || '#181c34');
        orgId &&
          needUpdate &&
          (await updateOrg(orgId, {
            theme: {
              primaryColor,
              logo,
              headerColor: value || '#181c34',
            },
          }));

        localStorage.setItem(
          'theme',
          JSON.stringify({
            primaryColor,
            headerColor: value || '#181c34',
            logo,
          })
        );
      } else if (key === 'logo') {
        setLogo(value || '');
        console.log('[uplate logo', orgId, needUpdate);
        orgId && needUpdate && (await updateOrg(orgId, { logo: value }));
        localStorage.setItem(
          'theme',
          JSON.stringify({
            primaryColor,
            headerColor,
            logo: value || '',
          })
        );
      }

      needUpdate && notify('success', 'Updated organization theme.');
    }, 750);

  return (
    <ThemeContext.Provider
      value={{
        primaryColor,
        headerColor,
        logo,
        setHeaderColor: handleChangeTheme('header'),
        setPrimaryColor: handleChangeTheme('primary'),
        setLogo: handleChangeTheme('logo'),
        setOrgId,
        setTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
